import React from "react";
import { cn } from "@/lib/tailwind-utils";
export const BaseNode = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { selected?: boolean }
>(({ className, selected, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "border border-muted-foreground bg-card p-2 text-card-foreground rounded-[15px]",
      className,
      selected ? "border-muted-foreground shadow-lg ring-4" : "",
      // "hover:shadow-lg",
    )}
    tabIndex={0}
    {...props}
  />
));
BaseNode.displayName = "BaseNode";
